import { HttpEventType, HttpResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  AfterContentChecked,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FileItem, FileUploader } from "ng2-file-upload";
import {
  Subscription,
  Observable,
  Subject,
  lastValueFrom,
  startWith,
  map,
  filter,
  takeUntil,
} from "rxjs";
import { AppParams, JobDynamicProp } from "src/app/core/models/appParams";
import {
  CloudTypes,
  FileTypes,
  HpcVMStates,
  JobTypes,
  PlatformTypes,
} from "src/app/core/models/globals";
import { Job, JobPriorityText, JobPriorityVal } from "src/app/core/models/job";
import { JsonFormData } from "src/app/core/models/jobJsonForm";
import { Node } from "src/app/core/models/node";
import {
  AzureStorageType,
  AzureTransferProgress,
} from "src/app/core/models/storage";
import { StorageDataType } from "src/app/core/models/storage-data-type";
import { ApplicationService } from "src/app/core/services/application.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { JobsService } from "src/app/core/services/jobs.service";
import { NodeService } from "src/app/core/services/node.service";
import { StorageDataTransferService } from "src/app/core/services/storage-data-transfer.service";
import { StorageService } from "src/app/core/services/storage.service";
import { UserService } from "../../../../../core/services/user.service";
import { StoreExplorerComponent } from "../../jobActions/store-explorer/store-explorer.component";
import {
  UserDetails,
  UserJobPathData,
  UserRolesInt,
  Users,
} from "src/app/core/models/users";
import { ManageZipDialogComponent } from "../../jobActions/manage-zip-dialog/manage-zip-dialog.component";
import { EnvironmentService } from "../../../../../core/services/environment.service";
import { FileEditorComponent } from "../../jobActions/file-editor/file-editor.component";
import { NgxSpinnerService } from "ngx-spinner";
import { StorageOracleService } from "src/app/core/services/storage-oracle.service";
import { HeaderService } from "src/app/core/services/header.service";
import { GoogleCloudService } from "../../../../../core/services/google-cloud.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { ActionLogService } from "src/app/core/services/action-log.service";
import { FileAlreadyExistsActionComponent } from "src/app/modules/storage/modals/file-already-exists-action/file-already-exists-action.component";
import { AwsCloudService } from "src/app/core/services/aws-cloud.service";

@Component({
  selector: "app-command-job",
  templateUrl: "./command-job.component.html",
  styleUrls: ["./command-job.component.scss"],
})
export class CommandJobComponent implements OnInit, AfterContentChecked {
  @ViewChild("dt1") dt1: any;
  constructor(
    public dialogRef: MatDialogRef<CommandJobComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cloudType: string;
      depName: string;
      appName: string;
      nodeName: string;
      jobName: string;
      isResubmit: boolean;
      suggestions: [];
      headNodeIp: string;
      alreadyAllocatedCores: number;
      copyJobDataToSyncstore: string;
      keepJobDataInWorkstore: string;
      isJobUpdatedFlag: boolean;
      routeViaSynchpc: boolean;
      tags: string | null;
    },
    public jobService: JobsService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    public storageDataTransferService: StorageDataTransferService,
    private applicationService: ApplicationService,
    private snackBar: MatSnackBar,
    private nodeService: NodeService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    private env: EnvironmentService,
    private _oracleService: StorageOracleService,
    private _headerService: HeaderService,
    private googleCloudService: GoogleCloudService,
    private deploymentService: DeploymentService,
    private configEntityService: ConfigEntityService,
    private actionLogService: ActionLogService,
    private myElement: ElementRef,
    private awsService: AwsCloudService,
  ) { }

  StdOutPattern: string = "^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9]+)?$";
  jobTag;
  commandJobForm: UntypedFormGroup;
  depName: string = this.data.depName;
  appName: string = this.data.appName;
  isHeadnodeActive: boolean = true;
  commandUploadSub: Subscription;
  priorities: string[] = [];
  groups: string[] = [];
  jobDetails: Job;
  cancelledFiles = {}; // contains subject of active uploads
  jobAdditionalInputFiles: StorageDataType[] = []; // contains list of inputfiles
  filesToCopy: string[] = []; // contains list of files which are to be copied
  selectedFiles: FileList; // contains list of files which are selected
  splitFiles = [];
  useFixedNoOfCores: boolean = false;
  staticCores: number[] = [];
  isUploadActive: boolean = false; // to check if upload is active
  minimumCores: number;
  maximumCores: number;
  suggestions: [] = this.data.suggestions;
  tagSuggestions: [] = [];
  filteredTagOptions: Observable<string[]>;
  filteredOptions: Observable<string[]>;
  maximumCoresAllowed: number = 0;
  cloudType: string = this.data.cloudType;
  uniqueAzureProgressId: number = 0;
  azureTransferSub: Subscription;
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  userNameForJobOutputDir: string = this.currentLoggedInUser && this.currentLoggedInUser.indexOf("@") > -1 ?
    this.currentLoggedInUser.split("@")[0] :
    this.currentLoggedInUser;
  headNodeIpForUpload: string = this.data.headNodeIp;
  todayDate = new Date().toISOString().substring(0, 16);
  users: Users;
  profileId: string = "";
  loggedInUser: string = this.authenticationService.currentUserValue.username;
  userInfoesData: UserDetails[];
  userDetails: Users;
  userRole: number;
  uploader: FileUploader = new FileUploader({
    url: this.deploymentService.getUrlForUtilityService(
      this.depName,
      this.data.headNodeIp,
      this.env.envVariables.UtilityAccessPort,
      1,
      this.data.routeViaSynchpc
    ),
    headers: [
      {
        name: "destinationpath",
        value: `${this.env.envVariables.syncStoreRoute}/${this.userNameForJobOutputDir}`,
      },
      { name: "requestUser", value: this.userNameForJobOutputDir },
    ],
    method: "post",
  });
  currentStorageName: string = this._headerService.getStorageNameForDeployment(
    this.depName
  );
  makeJobTagMandatoryFlag: boolean = this.env.envVariables.makeJobTagMandatory;
  customTagName: string = this.env.envVariables.customTagName;
  customTagValues: string[] = this.env.envVariables.customTagValues?.split(",");
  minDate = new Date(
    new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
  );
  maxDate = new Date(
    new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
  );
  submitJobWithoutHN: boolean =
    this.configEntityService.SyncHpcXMLParameters?.find(
      (x) => x.parameterName == "SubmitJobWithoutHN"
    )?.parameterValue == "true" || false;
  jobOutDir = `${this.env.envVariables.syncStoreRoute}/${this.userNameForJobOutputDir}/`;
  jobJson: JsonFormData;
  outDirMessage: string = this.env.envVariables.copyOutputToInputFileDirectory
    ? "Output directory will be same as input file directory"
    : this.jobOutDir;
  autoSubmitAfterUpload: boolean = false;
  userJobPathData: UserJobPathData;
  defaultStdOutFileName: string;
  defaultStdErrFileName: string;
  availableNodes: any[] = [];
  selectedNodeNames: string[] = [];
  reg: string = this.env.envVariables.fileUploadRegex;
  regexObj: any = new RegExp(this.reg);
  isResubmitMode: boolean = false;

  @ViewChild("commandBtnWorkStore") commandBtnWorkStore;

  public formData: JsonFormData;
  FileTypes = FileTypes;
  nodeData: Node[] = [];

  ngOnInit() {
    this.isResubmitMode = this.data.isResubmit;
    this.userService.getUserRole(this.loggedInUser).subscribe((data) => {
      this.userRole = Number(data);
      if (!this.data.isResubmit) {
        this.getSetAppVersionNodeGroup();
      }
    });
    this.createCommandJobForm();
    this.getTags();
    this.checkNodeData();
    this.arrangeJobNameSuggestions();
    this.updatePriority();
    if (this.env.envVariables.fixedNoOfCores) {
      this.assignFixedCores();
    }
    this.autoFillCommandResubmitForm();
    if (this.cloudType == CloudTypes.OnPremise) {
      this.configureNg2FileUpload();
    } else if (this.cloudType == CloudTypes.MicrosoftAzure) {
      this.checkAzureUpload();
    }
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  loadUserDetails() {
    this.userService
      .getUserJobDirectoryPath(this.loggedInUser, this.depName)
      .subscribe({
        next: (data) => {
          this.userJobPathData = <UserJobPathData>(
            JSON.parse(JSON.stringify(data))
          );
          if (this.userJobPathData.deploymentData.jobValue == 3) {
            this.commandJobForm.get("customWorkDirectoryPath").enable();
          }
        },
        error: (err) => { },
      });
    this.userService
      .getAllocatedCoreQuota(this.currentLoggedInUser, this.depName)
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (data != null) {
            let coreQuota = data.allocatedCoreQuota;

            if (coreQuota == -1) {
              //do nothing, check for compute node cores
            } else {
              if (coreQuota <= this.maximumCoresAllowed) {
                this.maximumCoresAllowed = coreQuota;
                this.maximumCoresAllowed =
                  this.maximumCoresAllowed - this.data.alreadyAllocatedCores;
              } else {
                this.maximumCoresAllowed =
                  this.maximumCoresAllowed - this.data.alreadyAllocatedCores;
              }
              this.commandJobForm
                .get("command_numberOfCoresMax")
                .setValidators([
                  Validators.max(this.maximumCoresAllowed),
                  this.commandJobForm.get("command_numberOfCoresMax").validator,
                ]);
              this.commandJobForm
                .get("command_numberOfCoresMax")
                .updateValueAndValidity();
            }
          }
        },
        error: (err) => { },
      });
  }

  getTags() {
    this.jobService
      .getApplicationTags(this.depName, this.appName)
      .subscribe((data: any) => {
        this.jobTag = data["tags"];
        this.tagSuggestions = data["tags"];
        this.defaultStdOutFileName = data["defaultStdOutFileName"];
        this.defaultStdErrFileName = data["defaultStdErrFileName"];
        this.arrangeTagSuggestions();
        if (this.commandJobForm && this.commandJobForm.controls["command_standardOutputFile"]) {
          this.commandJobForm.controls["command_standardOutputFile"].setValue(this.defaultStdOutFileName);
        }
      });
  }

  ngOnDestroy() {
    Object.values(this.cancelledFiles).forEach((file: Subject<null>) => {
      file.next(void 0);
      file.complete();
    });
    if (this.commandUploadSub) this.commandUploadSub.unsubscribe();
    if (this.snackBar) this.snackBar.dismiss();
    if (this.azureTransferSub) this.azureTransferSub.unsubscribe();
    this.uploader.cancelAll();
    this.snackBar.dismiss();
    this.snackBar.dismiss();
  }

  createCommandJobForm() {
    this.commandJobForm = new UntypedFormGroup({
      command_jobNamePrefix: new UntypedFormControl(
        "",
        Validators.pattern("^[A-Za-z0-9-_.@]+$")
      ),
      command_standardOutputFile: new UntypedFormControl(
        this.defaultStdOutFileName,
        Validators.pattern(this.StdOutPattern)
        //
      ),
      command_numberOfCoresMax: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
      ]),
      command_numberOfCoresMin: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
      ]),
      command_Priority: new UntypedFormControl(Validators.required),

      dependecy: new UntypedFormControl(null),
      jobID: new UntypedFormControl({ value: null, disabled: true }),
      command_startCommand: new UntypedFormControl(""),
      command_NodeGroup: new UntypedFormControl(null, Validators.required),
      command_Tag: new UntypedFormControl(this.data.tags),
      command_jobCommand: new UntypedFormControl(null, Validators.required),
      command_BackupData: new UntypedFormControl({
        value: this.data.copyJobDataToSyncstore,
        disabled: this.authenticationService.isUserGlobalAdmin ? false : true,
      }),
      command_keepWorkStoreData: new UntypedFormControl({
        value: this.data.keepJobDataInWorkstore,
        disabled: this.authenticationService.isUserGlobalAdmin ? false : true,
      }),
      command_endCommand: new UntypedFormControl(""),
      command_autoShut: new UntypedFormControl(false),
      command_jobSchedule: new UntypedFormControl(false),
      command_customDate: new UntypedFormControl(null),
      command_customTag: new UntypedFormControl(null),
      command_memoryPerCpu: new UntypedFormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      command_wallclockTime: new UntypedFormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      command_MinScratchSpace: new UntypedFormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      command_ScheduleTime: new UntypedFormControl(null),
      command_taskPerNode: new UntypedFormControl(0, [
        Validators.pattern("^[0-9]*$"),
      ]),
      command_isExclusive: new UntypedFormControl("1"),
      command_outputDirectory: new UntypedFormControl(null),
      customWorkDirectoryPath: new UntypedFormControl({
        value: null,
        disabled: true,
      }),
      command_NumOfGpuForJob: new UntypedFormControl(0),
      command_NumOfGpuPerTask: new UntypedFormControl(0),
      command_SelectedNodes: new UntypedFormControl([]),

    });

    this.commandJobForm.get("dependecy").valueChanges.subscribe((value) => {
      if (!value || value != "None") {
        this.commandJobForm.get("jobID").enable();
        this.commandJobForm.controls["jobID"].setValidators(
          Validators.required
        );
        this.commandJobForm.controls["jobID"].updateValueAndValidity();
      } else {
        this.commandJobForm.get("jobID").disable();
        this.commandJobForm.controls["jobID"].setValidators(null);
        this.commandJobForm.controls["jobID"].updateValueAndValidity();
      }
    });
    this.maxDate.setDate(this.minDate.getDate() + 7);
    this.commandJobForm.controls["command_customDate"].disable();
    if (this.makeJobTagMandatoryFlag) {
      this.commandJobForm.controls["command_Tag"].setValidators(
        Validators.required
      );
    }
    if (this.customTagName) {
      this.commandJobForm.controls["command_customTag"].setValidators(
        Validators.required
      );
    }
    this.commandJobForm.controls["command_jobSchedule"].valueChanges.subscribe(
      (val) => {
        if (val) {
          this.commandJobForm.controls["command_customDate"].setValue(
            this.todayDate
          );
          this.commandJobForm.controls["command_customDate"].enable();
          return;
        }
        this.commandJobForm.controls["command_customDate"].setValue(null);
        this.commandJobForm.controls["command_customDate"].disable();
      }
    );
    this.commandJobForm.get('command_NodeGroup')?.valueChanges.subscribe(value => {
      this.nodeGroupSelectionChange(value);
    });

  }

  autoFillCommandResubmitForm() {
    if (this.data.isResubmit) {
      this.spinner.show("resubmitJob");
      this.jobService
        .getJobDetailsForUser(this.depName, this.data.jobName)
        .subscribe((data) => {
          this.snackBar.dismiss();
          if (data) {
            this.jobDetails = <Job>JSON.parse(JSON.stringify(data));
            this.getSetAppVersionNodeGroup();
            let autoFillData: AppParams = JSON.parse(this.jobDetails.appPropJson);
            this.commandJobForm.controls["command_NumOfGpuForJob"].setValue(
              autoFillData.JobGenericProperties.NumOfGpuForJob
            );
            this.commandJobForm.controls["command_NumOfGpuPerTask"].setValue(
              autoFillData.JobGenericProperties.NumOfGpuPerTask
            );
            this.commandJobForm.controls["command_standardOutputFile"].setValue(
              autoFillData.JobGenericProperties.StdOutFile
            );
            this.setMinMaxCores(
              autoFillData.JobGenericProperties.ActualCores,
              autoFillData.JobGenericProperties.MinCores
            );
            this.commandJobForm.controls["command_NodeGroup"].setValue(
              autoFillData.JobGenericProperties.NodeGroup == ""
                ? ["Default"]
                : autoFillData.JobGenericProperties.NodeGroup.split(",")
            );
            this.commandJobForm.controls["command_Priority"].setValue(
              autoFillData.JobGenericProperties.JobPriority
            );
            this.commandJobForm.controls["command_startCommand"].setValue(
              autoFillData.JobGenericProperties.StartCommand
            );

            if (this.jobDetails?.application.toLowerCase() == "command") {
              this.commandJobForm.controls["command_jobCommand"].setValue(
                autoFillData.CommandProperties?.CommandLine
              );
            } else if (this.jobDetails?.application.toLowerCase() == "openfoam") {
              this.commandJobForm.controls["command_jobCommand"].setValue(
                autoFillData.OpenfoamProperties?.CommandLine
              );
            }

            this.commandJobForm.controls["command_BackupData"].setValue(
              autoFillData.JobGenericProperties.ToBackupData
            );
            this.commandJobForm.controls["command_keepWorkStoreData"].setValue(
              autoFillData.JobGenericProperties.KeepWorkStoreData
            );
            this.setAdditionalInputFiles(
              autoFillData.JobGenericProperties.FilesToCopy || ""
            );
            this.updateJobName(
              autoFillData.JobGenericProperties.JobName,
              this.jobDetails.number
            );
            this.commandJobForm.controls["command_endCommand"].setValue(
              autoFillData.JobGenericProperties.EndCommand
            );
            this.commandJobForm.controls["command_autoShut"].setValue(
              autoFillData.JobGenericProperties.IsAutoShut
            );
            this.commandJobForm.controls["command_customDate"].setValue(
              autoFillData.JobGenericProperties.CreateTime
            );
            this.commandJobForm.controls["command_memoryPerCpu"].setValue(
              autoFillData.JobGenericProperties.MemoryPerCpu
            );
            this.commandJobForm.controls["command_wallclockTime"].setValue(
              autoFillData.JobGenericProperties.WallclockTime
            );
            this.commandJobForm.controls["command_MinScratchSpace"].setValue(
              autoFillData.JobGenericProperties.MinScratchSpace
            );
            this.commandJobForm.controls["command_taskPerNode"].setValue(
              autoFillData.JobGenericProperties.TasksPerNode
            );
            this.commandJobForm.controls["command_isExclusive"].setValue(
              autoFillData.JobGenericProperties.ExclusiveJob.toString()
            );
            if (autoFillData.JobGenericProperties.NodeList) {
              this.commandJobForm.controls["command_SelectedNodes"].setValue(
                autoFillData.JobGenericProperties.NodeList.split(",")
              );
            } else {
              this.commandJobForm.controls["command_SelectedNodes"].setValue(['Default']);
            }
            // this.commandJobForm.controls["command_outputDirectory"].setValue(
            //   autoFillData.JobGenericProperties.OutDirectory ? autoFillData.JobGenericProperties.OutDirectory : this.jobOutDir
            // );
            this.spinner.hide("resubmitJob");
          }
        });
    }
  }

  getSetAppVersionNodeGroup() {
    if (
      this.userRole == UserRolesInt.GlobalAdmin ||
      this.userRole == UserRolesInt.DeploymentAdmin
    ) {
      this.applicationService
        .getNodeGroups(this.depName, this.appName)
        .subscribe((data) => {
          this.groups = <string[]>JSON.parse(JSON.stringify(data));
          this.configEntityService.getDeploymentConfigs(this.depName, this.cloudType).subscribe((data: any) => {
            data.forEach((setting) => {
              if (setting.parameterName == "Default Node Groups") {
                if (!this.data.isResubmit) {
                  this.commandJobForm.controls["command_NodeGroup"].setValue([
                    setting.parameterValue == ""
                      ? this.groups[0] : setting.parameterValue
                  ]);
                }
              }
            });
          });
        });
    } else {
      this.userService
        .getNodeGroup(this.currentLoggedInUser, this.depName)
        .subscribe((data) => {
          this.groups = <string[]>JSON.parse(JSON.stringify(data));
          this.configEntityService.getDeploymentConfigs(this.depName, this.cloudType).subscribe((data: any) => {
            data.forEach((setting) => {
              if (setting.parameterName == "Default Node Groups") {
                if (!this.data.isResubmit) {
                  this.commandJobForm.controls["command_NodeGroup"].setValue([
                    setting.parameterValue == ""
                      ? this.groups[0] : setting.parameterValue
                  ]);
                }
              }
            });
          });
        });
    }
  }

  updatePriority() {
    let priorityVal;

    this.userService
      .getJobPriority(this.currentLoggedInUser, this.depName)
      .subscribe({
        next: (data: any) => {
          if (data != null) {
            priorityVal = data.jobPro;
            for (let i = priorityVal; i <= 4; i++) {
              if (i === JobPriorityVal.Normal) {
                this.priorities.push(JobPriorityText.Normal);
              }
              if (i === JobPriorityVal.AboveNormal) {
                this.priorities.push(JobPriorityText.AboveNormal);
              }
              if (i === JobPriorityVal.BelowNormal) {
                this.priorities.push(JobPriorityText.BelowNormal);
              }
              if (i === JobPriorityVal.Highest) {
                this.priorities.push(JobPriorityText.Highest);
              }
              if (i === JobPriorityVal.Lowest) {
                this.priorities.push(JobPriorityText.Lowest);
              }
            }
            if (priorityVal <= JobPriorityVal.Normal) {
              this.commandJobForm.controls["command_Priority"].setValue(
                JobPriorityText.Normal
              );
            } else {
              this.commandJobForm.controls["command_Priority"].setValue(
                this.priorities[0]
              );
            }
          } else {
            this.priorities.push(JobPriorityText.Normal);
            this.commandJobForm.controls["command_Priority"].setValue(
              this.priorities[0]
            );
          }
        },
        error: (err) => {
          this.priorities.push(JobPriorityText.Normal);
          this.commandJobForm.controls["command_Priority"].setValue(
            this.priorities[0]
          );
        },
      });
  }

  assignFixedCores() {
    this.useFixedNoOfCores = true;
    this.staticCores = this.env.envVariables.fixedNoOfCores
      .split(",")
      .map((x) => +x);
    this.commandJobForm.controls["command_numberOfCoresMax"].setValue(
      this.staticCores[0]
    );
    this.commandJobForm.controls["command_numberOfCoresMin"].setValue(
      this.staticCores[0]
    );
    (this.minimumCores = this.staticCores[0]),
      (this.maximumCores = this.staticCores[0]);
  }

  onFileChange(inputName) {
    switch (inputName) {
      case "commandBtnWorkStore":
        this.commandBtnWorkStore.nativeElement.value = "";
    }
  }

  checkMaxCores() {
    if (this.minimumCores == undefined) {
      this.minimumCores = this.maximumCores;
    }
    if (this.minimumCores > this.maximumCores) {
      this.commandJobForm.controls["command_numberOfCoresMin"].setErrors({
        invalidCore: true,
      });
    } else {
      this.commandJobForm.controls["command_numberOfCoresMin"].setErrors(null);
    }
    this.minimumCores = this.maximumCores;
  }

  checkMinCores() {
    if (this.maximumCores == undefined) {
      this.maximumCores = this.minimumCores;
    }
    if (this.minimumCores > this.maximumCores) {
      this.commandJobForm.controls["command_numberOfCoresMin"].setErrors({
        invalidCore: true,
      });
    }
  }

  private arrangeJobNameSuggestions() {
    this.filteredOptions = this.commandJobForm
      .get("command_jobNamePrefix")
      .valueChanges.pipe(
        startWith(""),
        map((val) => this._filter(val, "jobName"))
      );
  }

  private arrangeTagSuggestions() {
    this.filteredTagOptions = this.commandJobForm
      .get("command_Tag")
      .valueChanges.pipe(
        startWith(""),
        map((val) => this._filter(val, "tag"))
      );
  }

  private _filter(value: string, type: string): string[] {
    const filterValue = value.toLowerCase();
    const suggestions = type == "tag" ? this.tagSuggestions : this.suggestions;
    return suggestions.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  isHeadNodeLinux: boolean = false;
  checkNodeData() {
    this.nodeService.getNodesForDeployment(this.depName).subscribe((data) => {
      if (!data) return;
      this.nodeData = <Node[]>JSON.parse(JSON.stringify(data));
      let headNode = this.nodeData.find((node) => node.nodeType.includes("Head"));
      if (headNode) {
        if (
          headNode.state != HpcVMStates.STATE_CODE_STARTED &&
          !this.submitJobWithoutHN
        ) {
          this.snackBar.open(
            "Headnode is not active, job cannot be submitted.",
            "Ok"
          );
          this.isHeadnodeActive = false;
        } else {
          this.isHeadnodeActive = true;
        }

        if (headNode.vmPlatform == PlatformTypes.Linux) {
          this.isHeadNodeLinux = true;
        }

        this.maximumCoresAllowed = this.nodeData
          .filter((el) => el.nodeType.toLowerCase().includes("compute"))
          .map((el) => el.cores)
          .reduce((total, curr) => total + +curr, 0);

        this.commandJobForm
          .get("command_numberOfCoresMax")
          .setValidators([
            Validators.max(this.maximumCoresAllowed),
            this.commandJobForm.get("command_numberOfCoresMax").validator,
          ]);
        this.commandJobForm
          .get("command_numberOfCoresMax")
          .updateValueAndValidity();
      }
      this.loadUserDetails();
      if (this.data.isResubmit && this.commandJobForm.get("command_NodeGroup")?.value) {
        this.nodeGroupSelectionChange(this.commandJobForm.get("command_NodeGroup").value);
      } 
    });
  }

  setMinMaxCores(max, min) {
    if (this.useFixedNoOfCores) {
      let idx;
      this.staticCores.findIndex((core) => {
        if (core == max) {
          idx = this.staticCores.findIndex((x) => x === max.toString());
        }
      });
      this.commandJobForm.controls["command_numberOfCoresMax"].setValue(
        this.staticCores[idx]
      );
      this.commandJobForm.controls["command_numberOfCoresMin"].setValue(
        this.staticCores[idx]
      );
    } else {
      this.commandJobForm.controls["command_numberOfCoresMax"].setValue(max);
      this.commandJobForm.controls["command_numberOfCoresMin"].setValue(min);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  async onSubmit(form) {
    try {
      this.isUploadActive = true;
      if (form.status == "INVALID") {
        this.commandJobForm.markAllAsTouched();
        this.showError(form);
        this.isUploadActive = false;
      } else {
        this.filesToCopy = [...new Set(this.filesToCopy)];
        let dynamicProp: JobDynamicProp[] = [];
        this.jobJson?.Controls.forEach((element) => {
          let propFormName = element.Name;
          let propName = element.Name.split("_")[1];
          let propValue = String(
            this.commandJobForm.controls[propFormName].value
          );
          dynamicProp.push({
            dynamicAppKey: propName,
            dynamicAppValue: propValue,
          });
        });
        var outPath = null;
        if (
          this.env.envVariables.copyOutputToInputFileDirectory &&
          this.filesToCopy.length > 0
        ) {
          outPath = this.filesToCopy[0].split("/").slice(0, -1).join("/");
        }
        var jobData: AppParams = {
          ProductToolName: this.data.appName,
          JobGenericProperties: {
            JobName: this.commandJobForm.value.command_jobNamePrefix,
            FilesToCopy: this.filesToCopy.join(","),
            OutDirectory: this.jobService.checkJobOutputDirectory(
              this.jobOutDir,
              this.commandJobForm.value.command_outputDirectory,
              outPath
            ),
            CustomWorkDirectoryPath:
              this.commandJobForm.value.customWorkDirectoryPath,
            StdOutFile: this.commandJobForm.value.command_standardOutputFile,
            IsAutoShut: this.commandJobForm.value.command_autoShut,
            ToBackupData: this.commandJobForm.get("command_BackupData").value,
            JobPriority: this.commandJobForm.value.command_Priority,
            NumOfCores: parseInt(
              this.commandJobForm.value.command_numberOfCoresMax,
              10
            ),
            ActualCores: parseInt(
              this.commandJobForm.value.command_numberOfCoresMax,
              10
            ),
            MinCores: parseInt(
              this.commandJobForm.value.command_numberOfCoresMin,
              10
            ),
            NodeGroup: this.commandJobForm.value.command_NodeGroup?.toString(),
            CustomTag: this.commandJobForm.value.command_customTag,
            AppVersion: "",
            IsInRecurrence: false,
            RepeatJobId: "",
            TotalRepetitions: null,
            CurrentRepetition: null,
            JobIntervalInHours: null,
            DownloadToMachine: -1,
            StartCommand: this.commandJobForm.value.command_startCommand,
            EndCommand: this.commandJobForm.value.command_endCommand,
            KeepWorkStoreData: this.commandJobForm.get(
              "command_keepWorkStoreData"
            ).value,
            CreateTime: this.commandJobForm.value.command_customDate || null,
            JobTag: this.commandJobForm.value.command_Tag,
            JobDependency: `${this.commandJobForm.value.dependecy}:${this.commandJobForm.value.jobID}`,
            MemoryPerCpu:
              this.commandJobForm.value.command_memoryPerCpu?.toString() ||
              null,
            WallclockTime:
              this.commandJobForm.value.command_wallclockTime?.toString() ||
              null,
            MinScratchSpace:
              this.commandJobForm.value.command_MinScratchSpace?.toString() ||
              null,
            BeginTime: form.value?.command_ScheduleTime
              ? new Date(
                form.value?.command_ScheduleTime?.getTime() -
                (330 +
                  form.value?.command_ScheduleTime?.getTimezoneOffset()) *
                60000
              )
                ?.toISOString()
                ?.split(".")[0]
              : null,
            JobMpi: null,
            TasksPerNode: +this.commandJobForm.value.command_taskPerNode || 0,
            ExclusiveJob: +this.commandJobForm.value.command_isExclusive,
            NumOfGpuForJob: this.commandJobForm.value.command_NumOfGpuForJob,
            NumOfGpuPerTask: this.commandJobForm.value.command_NumOfGpuPerTask,
            NodeList: (() => {
              const selectedNodes = this.commandJobForm.value.command_SelectedNodes || [];
              if (selectedNodes.includes('Default') || selectedNodes.length === 0) {
                return '';
              }
              return selectedNodes.join(",");
            })(),
          },
          FluentProperties: null,
          CfxProperties: null,
          CommandProperties: {
            CommandLine: this.commandJobForm.value.command_jobCommand,
            IsPlottable: false,
          },
          OpenfoamProperties: null,
          HfssProperties: null,
          MechanicalProperties: null,
          LsDynaProperties: null,
          StarCCMProperties: null,
          AbaqusProperties: null,
          ConvergeProperties: null,
          RadiossProperties: null,
          OptisProperties: null,
          NanoFluidXProperties: null,
          MscNastranProperties: null,
          MscActranProperties: null,
          OptiStructProperties: null,
          IsPlottable: false,
          ParentJobName: this.data.isJobUpdatedFlag ? this.jobDetails.name : "",
          IsUpdatedJob: this.data.isJobUpdatedFlag,
          DynamicAppProperties: dynamicProp,
        };
        if (this.data.isResubmit) jobData.ParentJobName = this.data.jobName;
        if (this.data.appName == JobTypes.OpenFoam) {
          jobData.ProductToolName = this.data.appName;
          jobData.CommandProperties = null;
          jobData.OpenfoamProperties = {
            CommandLine: this.commandJobForm.value.command_jobCommand,
            IsPlottable: true,
          };
        }

        const isAllow = await lastValueFrom(
          this.jobService.checkUserLicenseAvailability(
            this.depName,
            this.appName,
            jobData.JobGenericProperties.AppVersion,
            jobData.JobGenericProperties.NumOfCores
          )
        );

        if (!isAllow) {
          this.snackBar.open("Licenses are not available for the job.", "Ok", {
            duration: 5000,
          });
          this.isUploadActive = false;
          return;
        }
        this.jobService.submitJob(this.depName, jobData).subscribe({
          next: (data) => {
            this.snackBar.open(data.message, "Ok", { duration: 5000 });
            this.isUploadActive = false;
          },
          error: (err) => {
            this.snackBar.open(err.error.message, "Ok", { duration: 5000 });
            this.isUploadActive = false;
          },
        });
        this.dialogRef.close(true);
      }
    } catch (e) {
      this.isUploadActive = false;
    }
  }

  async checkForZipFile(fileName?) {
    const dialogRef = this.dialog.open(ManageZipDialogComponent, {
      width: "400px",
      disableClose: true,
      hasBackdrop: false,
      data: {
        fileName: fileName,
      },
    });
    return await lastValueFrom(dialogRef.afterClosed());
  }

  showError(form) {
    form.controls.command_numberOfCoresMax.touched = true;
    form.controls.command_jobCommand.touched = true;
    form.controls.command_Priority.touched = true;
    form.controls.jobID.touched = true;
    form.controls.command_Tag.touched = true;
    this.snackBar.open("Please fill / Verify all the required fields !", "Ok");
  }

  removeItem(file) {
    if (this.cloudType == CloudTypes.OnPremise) {
      let idx = this.uploader.queue.map((i) => i.file.name).indexOf(file.name);
      if (idx != -1) this.uploader.queue[idx].cancel();
    } else {
      if (this.cancelledFiles[file.name]) {
        this.cancelledFiles[file.name].next();
        this.cancelledFiles[file.name].complete();
      }
      this.storageDataTransferService.cancelAzureUpload(file.name);
    }
    this.filesToCopy = this.filesToCopy.filter((item) => item !== file.path);
    this.jobAdditionalInputFiles = this.jobAdditionalInputFiles.filter(
      (item) => item !== file
    );
    this.checkIfUploadIsActive();
    this.storageDataTransferService.cancelAzureUpload(file.name);
  }

  async selectFiles(event, id?: string, toLoadSync?: boolean) {
    if (!toLoadSync) {
      this.isUploadActive = true;
      const files = Array.from(event);
      files.forEach(async (file: File) => {
        if (file.name.match(this.regexObj)) {

          let dirPath =
            this.env.envVariables.jobFilesUploadPath +
            this.env.envVariables.slashType +
            this.userNameForJobOutputDir;
          let filePath = dirPath + this.env.envVariables.slashType + file.name;
          let perc: string = "Starting";
          let storageDataType = new StorageDataType(
            file.name,
            "file",
            filePath,
            perc
          );
          this.jobAdditionalInputFiles.push(storageDataType);
          let length = this.jobAdditionalInputFiles.length - 1;

          let logMsg = `${this.appName}: Uploading ${file.name} at path '${dirPath}': `;
          if (
            this.cloudType != CloudTypes.OnPremise &&
            dirPath !=
            (this.env.envVariables.syncStoreRoute ||
              this.env.envVariables.workStoreRoute)
          ) {
            if (logMsg.indexOf(this.env.envVariables.syncStoreRoute) == -1) {
              logMsg = `${this.appName}: Uploading ${file.name} at path "${this.env.envVariables.syncStoreRoute}/${dirPath}" : `;
            }
          }
          this.actionLogService.addActionLog(
            this.depName,
            "Upload",
            file.name,
            this.currentStorageName,
            "Job",
            logMsg
          );

          this.cancelledFiles[file.name] = new Subject();

          this.uniqueAzureProgressId = this.uniqueAzureProgressId + 1;
          let toZip: boolean = false;
          if (file.name.includes(".zip")) {
            toZip = await this.checkForZipFile(file.name);
          }
          if (this.cloudType == CloudTypes.MicrosoftAzure) {
            let index = this.jobAdditionalInputFiles
              .map((p) => p.name)
              .lastIndexOf(file.name);
            if (this.checkIfStorageIsBlobForAzure()) {
              this.storageDataTransferService
                .azureBlobJobsUploadFile(
                  dirPath,
                  file,
                  this.uniqueAzureProgressId
                )
                .then(
                  (data) => {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                  },
                  (error) => {
                    this.jobAdditionalInputFiles[index].value = "Failed";
                    this.checkIfUploadIsActive();
                  }
                );
            } else {
              this.storageDataTransferService
                .azureJobsUploadFile(dirPath, file, this.uniqueAzureProgressId)
                .then(
                  (data) => {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                  },
                  (error) => {
                    this.jobAdditionalInputFiles[index].value = "Failed";
                    this.checkIfUploadIsActive();
                  }
                );
            }
          } else if (this.cloudType == CloudTypes.OnPremise) {
            this.commandUploadSub = this.storageService
              .JobUploadFile(this.depName, dirPath, file, this.data.nodeName)
              .pipe(
                filter((file) => !!file),
                takeUntil(this.cancelledFiles[file.name])
              )
              .subscribe(
                (event: any) => {
                  if (event.type === HttpEventType.UploadProgress) {
                    if (this.jobAdditionalInputFiles[length] == undefined) {
                      length = this.jobAdditionalInputFiles.length - 1;
                    }
                    this.jobAdditionalInputFiles[length].value = Math.round(
                      (100 * event.loaded) / event.total
                    ).toString();
                  } else if (event instanceof HttpResponse) {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                    this.jobAdditionalInputFiles[length].isUploadCompleted =
                      true;
                  }
                },
                () => {
                  this.jobAdditionalInputFiles[length].value = "Failed";
                  this.checkIfUploadIsActive();
                  this.jobAdditionalInputFiles[length].isUploadCompleted = true;
                }
              );
          } else if (this.cloudType == CloudTypes.Oracle) {
            this._oracleService
              .uploadObject(filePath, file, this.currentStorageName)
              .pipe(
                filter((file) => !!file),
                takeUntil(this.cancelledFiles[file.name])
              )
              .subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.UploadProgress) {
                    if (this.jobAdditionalInputFiles[length] == undefined) {
                      length = this.jobAdditionalInputFiles.length - 1;
                    }
                    this.jobAdditionalInputFiles[length].value = Math.round(
                      (100 * event.loaded) / event.total
                    ).toString();
                  } else if (event instanceof HttpResponse) {
                    this.filesToCopy.push(
                      this._oracleService.arrangeDirPath(
                        toZip ? `${filePath}:Zipped` : filePath
                      )
                    );
                    this.checkIfUploadIsActive();
                    this.jobAdditionalInputFiles[length].isUploadCompleted =
                      true;
                  }
                },
                error: (err) => {
                  this.jobAdditionalInputFiles[length].value = "Failed";
                  this.checkIfUploadIsActive();
                  this.jobAdditionalInputFiles[length].isUploadCompleted = true;
                },
              });
          } else if (this.cloudType == CloudTypes.Google) {
            var url;
            this.googleCloudService
              .uploadFilePresignedUrl(
                this.depName,
                this.currentStorageName,
                filePath
              )
              .subscribe({
                next: (data) => {
                  url = data;
                  this.googleCloudService.uploadObject(url, file).subscribe({
                    next: (event: any) => {
                      if (event.type === HttpEventType.UploadProgress) {
                        if (this.jobAdditionalInputFiles[length] == undefined) {
                          length = this.jobAdditionalInputFiles.length - 1;
                        }
                        this.jobAdditionalInputFiles[length].value = Math.round(
                          (100 * event.loaded) / event.total
                        ).toString();
                      } else if (event instanceof HttpResponse) {
                        this.filesToCopy.push(
                          this.googleCloudService.arrangeDirPath(
                            toZip ? `${filePath}:Zipped` : filePath
                          )
                        );
                        this.checkIfUploadIsActive();
                        this.jobAdditionalInputFiles[length].isUploadCompleted =
                          true;
                      }
                    },
                    error: (err) => {
                      this.jobAdditionalInputFiles[length].value = "Failed";
                      this.checkIfUploadIsActive();
                      this.jobAdditionalInputFiles[length].isUploadCompleted =
                        true;
                      this.actionLogService.addActionLog(
                        this.depName,
                        "Upload",
                        file.name,
                        this.currentStorageName,
                        "Job",
                        logMsg,
                        1
                      );
                    },
                  });
                },
              });
          }
          else if (this.cloudType == CloudTypes.AWS) {
            this.awsService
              .uploadFilePresignedUrl(
                this.depName,
                this.currentStorageName,
                filePath
              )
              .subscribe({
                next: (data) => {
                  url = data;
                  this.awsService
                    .uploadObject(url, file)
                    .pipe(
                      filter((event) => !!event),
                      takeUntil(this.cancelledFiles[file.name])
                    )
                    .subscribe({
                      next: (event: any) => {
                        if (event.type === HttpEventType.UploadProgress) {
                          if (this.jobAdditionalInputFiles[length] == undefined) {
                            length = this.jobAdditionalInputFiles.length - 1;
                          }
                          this.jobAdditionalInputFiles[length].value = Math.round(
                            (100 * event.loaded) / event.total
                          ).toString();
                        } else if (event instanceof HttpResponse) {
                          // Fix this line - use the correct path arrangement
                          this.filesToCopy.push(
                            toZip ? `${filePath}:Zipped` : filePath
                          );
                          this.checkIfUploadIsActive();
                          this.jobAdditionalInputFiles[length].isUploadCompleted = true;
                        }
                      },
                      error: (err) => {
                        this.jobAdditionalInputFiles[length].value = "Failed";
                        this.checkIfUploadIsActive();
                        this.jobAdditionalInputFiles[length].isUploadCompleted = true;
                        this.actionLogService.addActionLog(
                          this.depName,
                          "Upload",
                          file.name,
                          this.currentStorageName,
                          "Job",
                          logMsg,
                          1
                        );
                      },
                    });
                },
                error: (err) => {
                  console.error('Error getting presigned URL:', err);
                  this.jobAdditionalInputFiles[length].value = "Failed";
                  this.checkIfUploadIsActive();
                }
              });
          }
        } else {
          this.snackBar.open(
            "File with special character and space cannot be uploaded.",
            "Ok",
            {
              duration: 5000,
            }
          );
          this.checkIfUploadIsActive();
        }
      });
    } else {
      //Use Syncstore
      for (let i = 0; i < event.length; i++) {
        let myFileValue = event[i];
        var items: string[] = myFileValue.split("/");
        let myFileText = items[items.length - 1];

        let toZip: boolean = false;
        if (myFileText?.includes(".zip")) {
          toZip = await this.checkForZipFile(myFileText);
        }
        if (myFileText.replace(":Zipped", "").match(this.regexObj)) {
          if (!id) {
            let type = myFileText.includes(".") ? "file" : "folder";
            let storageDataType = new StorageDataType(
              myFileText,
              type,
              toZip ? `${myFileValue}:Zipped` : myFileValue,
              null,
              null,
              null,
              null,
              true
            );
            if (this.jobAdditionalInputFiles) {
              if (
                this.jobAdditionalInputFiles?.some(
                  (fi) => fi.name == myFileText && fi.path == myFileValue
                )
              ) {
                const toOverwrite = await lastValueFrom(
                  this.dialog
                    .open(FileAlreadyExistsActionComponent, {
                      autoFocus: false,
                      disableClose: true,
                      width: "400px",
                      data: {
                        title: "File/Folder already exists",
                        message:
                          "File/Folder with name " +
                          myFileText +
                          " already selected.",
                      },
                    })
                    .afterClosed()
                );
              } else {
                this.jobAdditionalInputFiles.push(storageDataType);
              }
            } else {
              this.jobAdditionalInputFiles.push(storageDataType);
            }
          } else {
            if (event.length < 2) {
              this.commandJobForm.controls[id].setValue(
                myFileText.replace("Zipped", "")
              );
            } else {
              alert("Can't Select multiple files. Please select one.");
              return false;
            }
          }
          this.filesToCopy.push(toZip ? `${myFileValue}:Zipped` : myFileValue);
        } else {
          this.snackBar.open(
            "File with special character and space cannot be uploaded",
            "Ok",
            {
              duration: 5000,
            }
          );
        }
        this.checkIfUploadIsActive();
      }
    }
  }

  configureNg2FileUpload() {
    if (this.cloudType != CloudTypes.OnPremise) return;
    this.uploader.onProgressItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      this.jobAdditionalInputFiles[idx].value = String(item["progress"]);
    };

    this.uploader.onSuccessItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      this.filesToCopy.push(this.jobAdditionalInputFiles[idx].path);
      this.jobAdditionalInputFiles[idx].isUploadCompleted = true;
      this.checkIfUploadIsActive();
    };

    this.uploader.onErrorItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      this.jobAdditionalInputFiles[idx].value.ui_progress = "Failed";
    };

    this.uploader.onCompleteAll = () => {
      if (this.autoSubmitAfterUpload && !this.isUploadActive) {
        this.snackBar
          .open(
            "All files uploaded successfully. Submitting job in 5 seconds",
            "Cancel Submit",
            {
              duration: 5000,
            }
          )
          .afterDismissed()
          .subscribe((data) => {
            if (!data.dismissedByAction) {
              this.onSubmit(this.commandJobForm);
            } else {
              this.autoSubmitAfterUpload = false;
            }
          });
      }
    };
  }

  async startNg2Upload(e, id?) {
    if (this.cloudType != CloudTypes.OnPremise) {
      this.selectFiles(e, id);
      return;
    }
    let overWriteAll: boolean = false;
    let abortAll: boolean = false;
    const event: any = Array.from(e);
    for (let index = 0; index < Array.from(event).length; index++) {
      this.isUploadActive = true;
      let idx = this.uploader.queue
        .map((i) => i.file.name)
        .lastIndexOf(event[index].name);
      let item = this.uploader.queue[idx];
      item.withCredentials = false;
      //if (item.file.name.match(/^[A-Za-z0-9-_.@]+$/)) {
      if (item.file.name.match(this.regexObj)) {

        let dirPath =
          this.env.envVariables.jobFilesUploadPath +
          this.env.envVariables.slashType +
          this.userNameForJobOutputDir;
        let filePath =
          dirPath + this.env.envVariables.slashType + item.file.name;
        let toZip: boolean = false;
        if (item.file.name.includes(".zip")) {
          toZip = await this.checkForZipFile(item.file.name);
        }
        if (!overWriteAll) {
          const fileExists = await lastValueFrom(
            this.storageService.checkIfFileFolderExists(
              `${filePath}`,
              "",
              this.data.headNodeIp
            )
          );
          if (fileExists) {
            if (abortAll) {
              continue;
            }
            const result = await lastValueFrom(
              this.dialog
                .open(FileAlreadyExistsActionComponent, {
                  autoFocus: false,
                  disableClose: true,
                  width: "40vw",
                  data: {
                    title: "File/Folder already exists",
                    message:
                      "File/Folder with name " +
                      item.file.name +
                      " at path " +
                      dirPath +
                      " already exists. Please choose an action to perform.",
                    showAllButtons: event.length != 1,
                  },
                })
                .afterClosed()
            );
            if (!result || result == 1) {
              if (result == 1) abortAll = true;
              this.isUploadActive = false;
              continue;
            } else if (result == 3) {
              overWriteAll = true;
            }
          }
        }

        let storageDataType = new StorageDataType(
          item.file.name,
          "file",
          toZip ? `${filePath}:Zipped` : filePath,
          "Starting"
        );
        let logMsg = `Uploading ${item.file.name} at path '${dirPath}': `;
        this.actionLogService.addActionLog(
          this.depName,
          "Upload",
          item.file.name,
          this.currentStorageName,
          "Job",
          logMsg
        );

        if (this.jobAdditionalInputFiles) {
          if (
            this.jobAdditionalInputFiles?.some(
              (ipFile) => ipFile?.name == item?.file?.name
            )
          ) {
            this.jobAdditionalInputFiles = this.jobAdditionalInputFiles?.filter(
              (obj) => obj?.name != item?.file?.name
            );
            this.jobAdditionalInputFiles.push(storageDataType);
          } else {
            this.jobAdditionalInputFiles.push(storageDataType);
          }
        } else {
          this.jobAdditionalInputFiles.push(storageDataType);
        }

        this.uploader.uploadItem(item);
      } else {
        this.snackBar.open(
          "File with special character and space cannot be uploaded.",
          "Ok",
          {
            duration: 5000,
          }
        );
      }
    }
  }

  checkAzureUpload() {
    this.azureTransferSub =
      this.storageDataTransferService.azureTransferData.subscribe(
        (data: AzureTransferProgress[]) => {
          data.forEach((element) => {
            let idx = this.jobAdditionalInputFiles
              .map((log) => log.name)
              .lastIndexOf(element.name);
            if (idx != -1) {
              this.jobAdditionalInputFiles[idx].value = element.uploaded;
              if (element.uploaded == " : Upload Completed") {
                this.jobAdditionalInputFiles[idx].isUploadCompleted = true;
                this.checkIfUploadIsActive();
              }
            }
          });
        }
      );
  }

  loadSyncStoreFileTree(id?: string) {
    this.dialog
      .open(StoreExplorerComponent, {
        width: "50%",
        height: "70%",
        autoFocus: false,
        disableClose: true,
        data: { depName: this.depName, id: id, cloudType: this.cloudType },
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          if (!id) {
            this.selectFiles(response.data, null, true);
          } else {
            this.selectFiles(response.data, id, true);
          }
        }
      });
  }

  updateJobName(fileName, jobNumber?) {
    let jobName = this.commandJobForm.controls["command_jobNamePrefix"].value;
    if (jobName != null && jobName != undefined && jobName != "") {
      return;
    }
    if (fileName != "" && fileName != null) {
      let idx = fileName.lastIndexOf(".");
      if (idx >= 30) {
        idx = 30;
      }
      if (idx != -1) {
        fileName = fileName.substring(0, idx);
      }

      if (this.commandJobForm.value.command_jobNamePrefix == "") {
        let jobNamePrefix = fileName;
        if (jobNumber) {
          jobNamePrefix = jobNamePrefix + "_" + jobNumber + "R";
        }
        this.commandJobForm.controls["command_jobNamePrefix"].setValue(
          jobNamePrefix
        );
        this.commandJobForm.controls["command_jobNamePrefix"].markAsTouched();
      }
    }
  }

  setAdditionalInputFiles(name) {
    if (name != "") {
      let idx;
      this.splitFiles = name.split(",");
      let alreadyAdded: string[] = [];

      this.filesToCopy = this.filesToCopy.map((x) => x.split("/").slice(-1)[0]);

      this.splitFiles.forEach((x) => {
        let length = x.split("/").length;
        let fileName = x.split("/")[length - 1];
        if (this.filesToCopy.includes(fileName)) {
          idx = this.splitFiles.findIndex((file) => file == x);
          alreadyAdded.push(x);
        }
      });
      this.filesToCopy = this.splitFiles;
      this.splitFiles = this.splitFiles.filter(
        (val) => !alreadyAdded.includes(val)
      );
      this.splitFiles.forEach((file) => {
        let length = file.split("/").length;
        let fileName = file.split("/")[length - 1];
        let storageDataType = new StorageDataType(fileName, "file", file);
        let idx = this.jobAdditionalInputFiles.findIndex(
          (a) => a.name == storageDataType.name
        );
        if (idx == -1) {
          this.jobAdditionalInputFiles.push(storageDataType);
        }
      });
    }
  }

  checkIfUploadIsActive() {
    if (
      this.jobAdditionalInputFiles &&
      this.jobAdditionalInputFiles.length != 0
    ) {
      this.jobAdditionalInputFiles.forEach((x) => {
        if (this.jobService.uploadValues.includes(x.value)) {
          this.isUploadActive = false;
        } else {
          this.isUploadActive = true;
        }
      });
    } else {
      this.isUploadActive = false;
    }
  }

  toogleDialog: boolean = false;
  toogleDialogMinMax() {
    this.toogleDialog = !this.toogleDialog;

    const currentElement = this.myElement.nativeElement;

    let dialogElement = currentElement.parentElement;
    while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
      dialogElement = dialogElement.parentElement;
    }

    if (!dialogElement) {
      console.error('Could not find parent overlay pane');
      return;
    }


    if (this.toogleDialog) {
      dialogElement.classList.add('minimize2');
      dialogElement.classList.remove('maximize');
    } else {
      dialogElement.classList.remove('minimize2');
      dialogElement.classList.add('maximize');

      setTimeout(() => {
        dialogElement.classList.remove('maximize');
      }, 300);
    }
  }

  openFileEditor(filePath?: string) {
    const dialogRef = this.dialog
      .open(FileEditorComponent, {
        disableClose: true,
        autoFocus: true,
        width: "70%",
        height: "80%",
        id: "editorDialog",
        panelClass: "file-editor-dialog",
        data: {
          depName: this.depName,
          cloudType: this.data.cloudType,
          filePath: filePath,
          headNodeIp: this.headNodeIpForUpload,
          routeViaSynchpc: this.data.routeViaSynchpc,
        },
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe({
        next: (data) => {
          if (data) {
            if (filePath) {
              this.jobAdditionalInputFiles =
                this.jobAdditionalInputFiles.filter(
                  (file) => file.path !== filePath
                );
              this.filesToCopy = this.filesToCopy.filter(
                (item) => item !== filePath
              );
            }
            let fileItem = new FileItem(this.uploader, data, { url: "" });
            this.uploader.queue.push(fileItem);
            this.startNg2Upload([data]);
          }
        },
      });
  }

  editItem(file) {
    this.openFileEditor(file.path);
  }

  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nodeGroupSelectionChange(group) {
    if (this.commandJobForm.controls["command_NodeGroup"].status != "INVALID") {
      if (this.commandJobForm.get("command_NodeGroup").value != null && this.commandJobForm.get("command_NodeGroup").value != "") {
        const keywords = this.commandJobForm.get("command_NodeGroup")?.value.map(keyword => keyword.trim());
        let result: { [keyword: string]: Node[] } = {};

        if (keywords.length == 1 && keywords[0] == "Default") {
          result["Default"] = this.nodeData.filter((el) => el.nodeType.toLowerCase().includes("compute"));
        }
        else if (keywords.includes("Default")) {
          result["Default"] = this.nodeData.filter((el) => el.nodeType.toLowerCase().includes("compute"));
        }
        else {
          keywords.forEach(keyword => {
            result[keyword] = this.nodeData.filter(person => {
              const familyContainsKeyword = person.azureServiceName != null && person.azureServiceName != "" && keyword != "Default" &&
                person.azureServiceName.split(',').some(x => x == keyword) &&
                person.nodeType.toLowerCase().includes("compute");
              return familyContainsKeyword;
            });
          });
        }

        if (result != null) {
          this.maximumCoresAllowed = 0;
          console.log("Filtered Node Data: ", result);
          if (Object.keys(result).length == 1) {
            this.maximumCoresAllowed = result[Object.keys(result)[0]].reduce((sum, node) => sum + +node.cores, 0);
          }
          else if (Object.keys(result).length > 1) {
            const sumsPerKey = Object.keys(result).map(key =>
              result[key].reduce((sum, node) => sum + +node.cores, 0)
            );
            this.maximumCoresAllowed = Math.min(...sumsPerKey);
          }
          // NEW CODE: Extract all available nodes for the dropdown
          this.availableNodes = [];
          Object.keys(result).forEach(nodeGroup => {
            result[nodeGroup].forEach(node => {
              if (!this.availableNodes.find(n => n.vmName === node.vmName)) {
                this.availableNodes.push({
                  vmName: node.vmName,
                  vmId: node.vmId,
                  cores: node.cores,
                  instanceType: node.instanceType,
                  nodeGroup: nodeGroup,
                  displayName: node.vmName
                });
              }
            });
          });

          // Set default selection based on node group
          if (!this.isResubmitMode) {
            this.commandJobForm.controls['command_SelectedNodes'].setValue(['Default']);
          }
          

          this.commandJobForm.controls["command_numberOfCoresMax"].setValidators(
            [
              Validators.required,
              Validators.min(1),
              Validators.max(this.maximumCoresAllowed),
              Validators.pattern(/^[0-9]+$/),
            ]
          )
          this.commandJobForm.controls["command_numberOfCoresMax"].updateValueAndValidity();
        }
      }
    }
  }
  onCommandNodeSelectionChange(event: any) {
    const selectedValues = event.value;

    if (!selectedValues || selectedValues.length === 0) {
      this.commandJobForm.controls['command_SelectedNodes'].setValue(['Default'], { emitEvent: false });
      return;
    }

    const hasDefault = selectedValues.includes('Default');
    const hasOtherNodes = selectedValues.some(value => value !== 'Default');

    if (hasDefault && hasOtherNodes) {
      // Check if the most recently selected option was 'Default'
      const recentlySelected = event.source.selected;
      const defaultOption = recentlySelected.find(option => option.value === 'Default');

      if (defaultOption && event.source._keyManager.activeItem === defaultOption) {
        // User clicked on 'Default', so keep only Default
        this.commandJobForm.controls['command_SelectedNodes'].setValue(['Default'], { emitEvent: false });
      } else {
        // User clicked on specific nodes, so remove Default
        const filteredValues = selectedValues.filter(value => value !== 'Default');
        this.commandJobForm.controls['command_SelectedNodes'].setValue(filteredValues, { emitEvent: false });
      }
    }
  }
  isNodeGroupDisabled(group) {
    if (this.commandJobForm.controls["command_NodeGroup"].status != "INVALID") {
      return (
        this.commandJobForm.get("command_NodeGroup")?.value?.length >= 2 &&
        !this.commandJobForm.get("command_NodeGroup")?.value?.includes(group)
      );
    }
  }

  isOptionDisabled(opt: any): boolean {
    if (this.commandJobForm.controls["command_NodeGroup"].status != "INVALID") {
      this.snackBar.open("Maximum limit reached", "OK", { duration: 1000 });
      return (
        this.commandJobForm.controls["command_NodeGroup"]?.value?.length == 2 &&
        !this.commandJobForm.controls["command_NodeGroup"]?.value?.find(
          (el) => el == opt
        )
      );
    }
  }

  valueChanged() {
    this.commandJobForm.controls["command_ScheduleTime"].setValue(null);
    this.commandJobForm.controls["command_ScheduleTime"].setValue(
      new Date(
        new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
      )
    );
  }

  clearDate() {
    this.commandJobForm.controls["command_ScheduleTime"]?.setValue(null);
  }

  azureStorageType: AzureStorageType;
  checkIfStorageIsBlobForAzure() {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      let deployment = this.deploymentService.getProfileInfoFromSubject(
        this.depName
      );
      if (!deployment) return false;
      if (!this.azureStorageType) {
        this.azureStorageType = deployment.storageType
          ? (deployment.storageType as AzureStorageType)
          : null;
      }
      if (this.azureStorageType == AzureStorageType.TxtBlobStorage) {
        return true;
      }
    }
    return false;
  }

  // Blocks keys that would create invalid numbers
  blockInvalidDigits(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.includes(event.key)) return;

    // Get current value and potential new value
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const newValue = parseInt(currentValue + event.key);

    // Block if new value would exceed max or be non-numeric
    if (isNaN(newValue) || newValue > this.maximumCoresAllowed) {
      event.preventDefault();
    }
  }
}
